import { AxiosResponse } from 'axios';
import { IRoadData } from '../../classes/loaders/RoadLoader';
import v2 from '../v2';

export const createRoad = async (data: IRoadData, index: number, trigger: any, reset: any) => {
  await new Promise(resolve => setTimeout(resolve, 50 * index));
  await v2.post<string>('/geojson/road', data);
  trigger();
  if (reset) {
    reset();
  }
};

export const findNearRoads = async (center: ILngLat, radius: number) => {
  return await v2.get<Array<{
    wgs84: IRoadData;
  }>>('/geojson/road', {
    params: {
      center,
      radius,
    },
  });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/geojson/road.ts